export default function LiveDiv( { size, color } ){
    const style = {
        width: size,
        height: size,
        backgroundColor: color,
        borderRadius : "100%",

        // animation
        opacity: 0,
        animation: 'breathe 1.5s ease-in-out infinite'
    };

    return(
        <>
          <style>{`@keyframes breathe { 0% { opacity: 0.25; } 50% { opacity: 1; } 100% { opacity: 0.25; } }`}</style>
          <div style = { style } />
        </>
    )
}